import React from 'react'
import { FiEdit } from 'react-icons/fi'
import { personals } from './mock'


export const Personal = () => {
    
    return (<div className="personal">
          
        <div className="heading">
            <h4>Personal</h4>
            <div onClick={(e) =>{
                e.preventDefault()
            }}><FiEdit /></div>
        </div>

        <ul>
           {
               personals.map(item=>{
                   return (
                    <li 
                    onClick={(e)=>{
                    }}
                    className={`${item.add === true && 'add'}`}
                    >
                        <div className="symbol">{item.symbol}</div> 
                        <div>
                            <h5 className="p_title">{item.title}</h5>
                            <p className="p_description">{item.description}</p>
                        </div>
                    </li>
                   )
               })
           }
        </ul>

    </div>)
}